<template>
  <div class="GirisSayfa">
    <div class="GirisCont">
      <el-row :gutter="24">
        <el-col :sm="24" :md="{span:6,offset:9}">
          <div class="GirisForm">
            <img src="https://cdn.mudu.pro/Design/asansorcrm.svg" class="girislogo">
            <h1>Kayıt Ol</h1>
            <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
                     ref="Form">
              <el-form-item label="Firma Adı" prop="fadi">
                <el-input type="text" v-model="Form.fadi" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="Adı Soyadı" prop="adi">
                <el-input type="text" v-model="Form.adi" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="E-Mail Adresi" prop="Email">
                <el-input type="email" v-model="Form.Email" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="Telefon" prop="telefon">
                <el-input type="text" v-model="Form.telefon" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="Şifre" prop="pass">
                <el-input type="password" v-model="Form.pass" autocomplete="off" show-password></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="d-block" @click="Gonder()" :loading="lo">Gönder</el-button>
              </el-form-item>
            </el-form>
            <router-link tag="a" to="/giris">Giriş Yap</router-link>
            <el-col :span="24" class="text-center"><a class="mudulogo" href="https://mudu.com.tr"><img
                src="https://cdn.mudu.pro/Design/mudu.svg"> </a></el-col>


          </div>
        </el-col>

      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lo: false,
      Form: {
        Email: '',
        Parola: ''
      },
      FormHata: {
        fadi: [{required: true, message: "Firma Adı Giriniz", trigger: 'blur'}],
        adi: [{required: true, message: "Ad Soyad Giriniz", trigger: 'blur'}],
        telefon: [{required: true, message: "Telefon Giriniz", trigger: 'blur'}],
        Email: [{required: true, message: "Email Giriniz", trigger: 'blur'}],
        pass: [{required: true, message: "Parola Giriniz", trigger: 'blur'}],
      },
    }
  },
  methods: {
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          this.$store.dispatch("Post", {...this.Form, path: 'auth/kayit'})
              .then(response => {
                if (response.Durum == "OK") {
                  // location.reload();
                  this.$router.push("/giris")
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    }
  }
}
</script>
<style>
.GirisSayfa {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #4285f4;
}

.GirisForm {
  text-align: center;

  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 0 4px 8px rgb(0 0 0 / 17%);
  background-color: #fbfbfb;
  padding: 20px;
}

.GirisCont {
  margin: auto;
  align-self: flex-start;
  width: 100%;
}

.girislogo {
  width: 60%;
  margin: 20px 0;
}

.mudulogo {
  margin-top: 50px;
  position: relative;
  display: block;
}

.mudulogo img {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Kayit/Index.vue